export const sampleText = 'function myEval(code){return eval(code)}function handleJSONP\»(a){return a}(function(){function a(b){var c=myEval(b)}})();';



/** WEBPACK FOOTER **
 ** ./src/sampleText.js
 **/